import {getQueryClient} from '@github-ui/query-client'

export const queryClient = getQueryClient()

queryClient.setQueryDefaults(['memex'], {retry: 1})
